module.exports = __webpack_public_path__ + "img/sekhukhune-united-logo-icon.cfdd9ee1.png";